/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_G1Inputs */

const en_mk_mx_g1 = /** @type {(inputs: Mk_Mx_G1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace basics`)
};

const id_mk_mx_g1 = /** @type {(inputs: Mk_Mx_G1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasar ruang kerja`)
};

/**
* | output |
* | --- |
* | "Workspace basics" |
*
* @param {Mk_Mx_G1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_g1 = /** @type {((inputs?: Mk_Mx_G1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_G1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_g1(inputs)
	return en_mk_mx_g1(inputs)
});